<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid pt-3" style="height:100%;">
    <div class="row">
      <div class="col" style="height:100%;">
        <div class="timeline timeline-left">
          <div class="timeline-container" id="timeline-container-id">

            <div class="timeline-row" style="z-index: unset !important;" v-for="(val, index) in procedureHistory">
              <div class="timeline-icon">
                <div v-bind:class="val.StatusCssClass"></div>
              </div>
              <div class="card shadow-0 border-0 history_contanier skin light-bg p-2" style="display:block">
                <span class="text-default" v-html="val.Title"></span>
                <map-button v-show="val.Lattitude != null && val.Lattitude != ''" v-bind:latitude="val.Lattitude" v-bind:longitude="val.Longitude" class="ml-1"></map-button>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>

  import MapButton from "../maps/map-button.vue";
  import containerExpandRight from '../containers/container-expand-right.vue'
  import vuescroll from 'vuescroll';


  var statuses = [
    'created',
    'started',
    'done',
    'verified',
    'closed'
  ]


  export default {
    name: "procedure-sch-historymode",
    components: {
      containerExpandRight,
      vuescroll,
      MapButton
    },
    props: {
      proSchId: {
        required: false,
        type: String,
        default: null
      }
    },
    computed: {
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 19");
          this.$store.commit('saveprocedure', value)
        }
      }
    },
    data() {
      return {
        procedureHistory: [],
        statuses,
        ops: {
          vuescroll: {
            mode: 'slide',
          },
          scrollPanel: {
            scrollingX: false
          },
          rail: {
            background: '#F6F7F7',
            opacity: 0.5,
            size: '6px',
            specifyBorderRadius: false,
            gutterOfEnds: null,
            gutterOfSide: '2px',
            keepShow: false
          },
          bar: {
            onlyShowBarOnScroll: false,
            keepShow: true,
            background: '#666767',
          }
        }
      };
    },

    methods: {
      getStatusname(id) {
        if (id < this.statuses.length)
          return this.statuses[id];
        return "";
      },

      loadProcedureSchHistory() {
        try {
          var offset = new Date().getTimezoneOffset();
          var procSchId = this.proSchId;
          if (procSchId !== null && typeof (procSchId) != "undefined" && procSchId != "") {
            this.$http.get('/api/Procedures/v1/GetProcSchHistoryDetail?procSchid=' + procSchId + '&offset=' + offset).then(async response => {
              this.procedureHistory = response.data;
            });
          }
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      goto(id) {
        this.$parent.scheduleid = id;
      },
      loadThread(id) {
        //alert('loading thread for id:' + id);
      },
      handleRefresh(val) {
        this.$forceUpdate();
      }
    },
    mounted() {
      //this.loadProcedureSchHistory();

      this.statuses[0] = this.$t('created');
      this.statuses[1] = this.$t('started');
      this.statuses[2] = this.$t('done');
      this.statuses[3] = this.$t('verified');
      this.statuses[4] = this.$t('closed');

    },
    created() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>
  #timeline-container-id::after {
    z-index: 1 !important;
  }

  .timeline-row {
    z-index: 2 !important;
  }

  .history_contanier {
    box-shadow: none;
  }

    .history_contanier .header-elements-inline {
      padding-top: 1.0rem;
    }

  .timeline-icon {
    
    width: 24px;
    height: 24px;
   
  }


  @media (min-width: 768px) {
    .timeline-icon {
      margin-left: 12px !important;
      margin: 0 auto 1.25rem 0.4rem;
    }
  }

  @media (max-width: 768px) {
    
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-sch-historymode.vue